export default {
  zh: {
    enterCodeNotice: '输入您邮箱收到的验证码',
    placeholder: {
      yourCode: '在此输入验证码'
    },
    submit: '提交',
    notReceived: '未收到？',
    resend: '重新发送验证邮件',
    sent: '已发送（ ',
    seconds: 's ）'
  },
  en: {
    enterCodeNotice: 'Please enter the verification code you have received in your email',
    placeholder: {
      yourCode: 'Your Code'
    },
    submit: 'Submit',
    notReceived: 'Didn’t receive?',
    resend: 'Resend',
    sent: 'Resend (',
    seconds: 's)'
  }
}



// WEBPACK FOOTER //
// ./src/views/verifyEmailForm/lang.js